import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { Notification, NotificationLevel } from 'src/app/model/notification';
import { AppState } from 'src/app/store/app.reducer';
import { selectToastNotification } from 'src/app/store/notifications/notifications.selector';

import * as NotificationsActions from "../../../../store/notifications/notifications.actions";
import { Observable, Subscription, filter } from 'rxjs';

@Component({
  selector: 'app-notificationtoaster',
  templateUrl: './notification-toaster.component.html',
  providers: [MessageService],
})
export class NotificationToasterComponent implements OnInit, OnDestroy {
  toastNotificationSel$: Observable<Notification | undefined>;
  toastNotificationSub: Subscription | undefined;

  constructor(
    private store: Store<AppState>,
    private messageService: MessageService,
    private translateService: TranslateService
  ) {
    this.toastNotificationSel$ = this.store.select(selectToastNotification);
  }

  ngOnInit(): void {
    this.toastNotificationSub = this.toastNotificationSel$
      .pipe(filter((notification: Notification | undefined) => notification!==undefined ))
      .subscribe((notification: Notification | undefined) =>
        this.toastNotificationCallback(notification)
      );
  }

  ngOnDestroy(): void {
    if (this.toastNotificationSub) {
      this.toastNotificationSub?.unsubscribe();
    }
  }

  toastNotificationCallback(notification: Notification | undefined): void {
    if(notification) {
      let severity = 'info';
      // let summary = 'info';
      switch (notification.level) {
        case NotificationLevel.Info:
          severity = 'info';
          // summary = 'Information';
          break;
        case NotificationLevel.Error:
          severity = 'error';
          // summary = 'Error';
          break;
        case NotificationLevel.Success:
          severity = 'success';
          // summary = 'Success';
          break;
        case NotificationLevel.Warning:
          severity = 'warn';
          // summary = 'Warning';
          break;
      }
      this.messageService.add({
        key: 'notifications',
        severity: severity,
        summary: this.translateService.instant(notification.summary),
        detail: this.translateService.instant(notification.message),
      });
      this.store.dispatch(NotificationsActions.clearToastNotification());
    }
  }
}
